import { serializeQuery } from "../../../utils";
import { z } from "zod";
import {
  DTOExporterCreateInput,
  DTOExporterResponse,
  DTOExporterListQuery,
  DTOExporterListResponse,
  DTOExporterDeprecationInput,
  DTOExporter,
} from "../../dto";
import { RequestExecutor } from "../../transport";

export class ExportersEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  add(workspaceId: string, body: DTOExporterCreateInput) {
    return this.requestExecutor.json(`/codegen/workspaces/${workspaceId}/exporters`, DTOExporterResponse, {
      body,
      method: "POST",
    });
  }

  list(workspaceId: string, query?: DTOExporterListQuery) {
    return this.requestExecutor.json(`/codegen/workspaces/${workspaceId}/exporters`, DTOExporterListResponse, {
      query: query ? serializeQuery(query) : undefined,
    });
  }

  get(workspaceId: string, exporterId: string) {
    return this.requestExecutor.json(`/codegen/workspaces/${workspaceId}/exporters/${exporterId}`, DTOExporterResponse);
  }

  deprecate(workspaceId: string, exporterId: string, body: DTOExporterDeprecationInput) {
    return this.requestExecutor.json(
      `/codegen/workspaces/${workspaceId}/exporters/${exporterId}/deprecation`,
      DTOExporter,
      {
        body,
        method: "PUT",
      }
    );
  }

  pullChanges(workspaceId: string, exporterId: string) {
    return this.requestExecutor.json(
      `/codegen/workspaces/${workspaceId}/exporters/${exporterId}`,
      DTOExporterResponse,
      {
        body: {},
        method: "PUT",
      }
    );
  }
}
